/* eslint-disable camelcase */

export default class DtoPgsseDocument {
    constructor(obj) {
        this.idDiagnostic = obj.idDiagnostic
        this.lexId = obj.lexId
        this.otherDocName = obj.otherDocName
        this.existing = obj.existing
        this.date = obj.date
        this.relevance = obj.relevance
        this.updateDate = obj.updateDate
        this.updateLogin = obj.updateLogin
        this.comment = obj.comment

        this.index = obj.index
        this.toUpdate = true
    }
}
